// Croatian

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `otvoreno do ${date}` : ''),
    },
    interview: {
      title: 'Odgovor na videorazgovor',
      submit: 'Pošalji odgovore i završi razgovor',
      continueLater: 'Nastavi poslije',
      startInterview: 'Započni razgovor',
      duplicateError: 'Već ste sudjelovali u ovom razgovoru. Primili ste e-poruku od invitations@recright.com s poveznicom putem koje možete nastaviti razgovor.',
      confirmSubmitHeader: 'Niste odgovorili na sva pitanja postavljena na razgovoru',
      confirmSubmitContent: 'Želite li zaista završiti ovaj razgovor?',
      confirmSubmitContentWarning: ' Nakon toga više nećete moći dovršiti odgovore.',
      submitInterviewHeader: 'Pošaljite svoje odgovore za intervju',
      submitInterviewContent: 'Jeste li sigurni da želite poslati intervju?',
      confirmSubmitButton: 'Pošalji odgovore i završi razgovor',
      preview: 'Ovdje možete pogledati pregled pitanja u videozapisu.',
      requiredQuestionsNotAnswered: 'Molimo odgovorite na sva obavezna pitanja prije slanja.',

      withdrawLink: 'Za ovu poziciju više niste zainteresirani? Ovdje se možete povući iz postupka.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Ime',
      city: 'Grad',
      email: 'E-pošta',
      phone: 'Broj telefona',
      link: 'Poveznica',
      legendBasicInfo: 'Osnovne informacije',
      placeholderName: 'Upišite ime',
      placeholderEmail: 'Upišite e-adresu',
      placeholderPhone: 'Upišite broj telefona',
      placeholderCity: 'Upišite ime trenutnog grada stanovanja',
      placeholderLink: 'Dodajte poveznicu, na primjer na vaš profil na LinkedInu.',
      legendAttachments: 'Privici',
      legendAdditionalFields: 'Dodatne informacije',
      required: 'Stvake označene zvjezdicom (*) potrebno je ispuniti.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Zvuk',
        video: 'Videozapis',
        yes: 'Da',
        no: 'Ne',
        supported: 'Podržano',
        quality: 'Kvaliteta',
        header: 'Mrežna veza i provjera uređaja',
        description: 'Sada ćemo obaviti provjeru kako bismo utvrdili rade li ispravno vaša mrežna veza i hardver potrebni za razgovor (kamera i telefon). Kada se pojavi upit, pustite da se u postupku provjere upotrijebi kamera i mikrofon te provjerite je li kamera prekrivena. Provjera traje približno 30 sekundi. Preporučujemo vam da govorite tijekom izvođenja provjere hardvera.',
        inProgress: 'Provjeravanje u tijeku...',
        networkTestResults: 'Rezultati provjere mreže',
        qualityTestResults: 'Rezultati provjere kvalitete',
        testPassedQuality: 'Minőségi teszt sikeres',
        testFailedQuality: 'Minőségi vizsgálat sikertelen',
        testPassedNetwork: 'Hálózat vizsgálata sikeres',
        testFailedNetwork: 'Hálózati teszt sikertelen',
        startTest: 'Pokreni provjeru',
        startInterview: 'Pokreni razgovor',
        testAgain: 'Ponovno provjeri',
        confirmWarning: 'Nakon što vaš video-razgovor za posao započne, automatski ćete biti usmjereni prema prvom pitanju u razgovoru. Nakon što pogledate pitanje, bit ćete usmjereni prema pripremi.',
        confirmTitle: 'Uskoro ćete započeti razgovor',
        confirmText: 'Prije svakog pitanja, imat ćete na raspolaganju kraće vrijeme za pripremu svojeg odgovora. Nakon pripreme, imat ćete unaprijed određeno vrijeme da odgovorite na pitanje. Ne zaboravite da svoj odgovor možete poslati čim ste spremni, čak i prije nego što istekne unaprijed određeno vrijeme za odgovaranje.',
        confirmText2: 'Nakon slanja odgovora idete na sljedeće pitanje sve dok ne odgovorite na sva pitanja.',
        confirmText3:
          'Napominjemo da ćete, nakon što zabilježite vaš odgovor na pitanje, imati 30 sekundi vremena da ponovno odgovorite ako je ponovno odgovaranje za to pitanje omogućeno. Ako ne pokrenete ponovno odgovaranje unutar tog razdoblja od 30 sekundi, vaš trenutni odgovor bit će poslan automatski, a vi ćete biti upućeni na sljedeće pitanje.',
        goodLuck: 'Samo duboko udahnite i sve će biti uredu. Sretno!',
        qualityRating: {
          excellent: 'Odlična',
          good: 'Dobra',
          fair: 'Dovoljna',
          poor: 'Nedovoljna',
          bad: 'Loša',
        },
      },
      questionAnswerView: {
        title: title => `Odgovori u razgovoru ${title}`,
        question: 'Pitanje',
        submitAndNext: 'Pošalji i idi na sljedeće pitanje',
        submitSuccess: 'Videozapis je uspješno poslan!',
        skipText: 'Pokreni snimanje',
        stop: 'Zaustavi',
        submitAndFinish: 'Pošalji i završi intervju',
        retake: 'Ponovno pokušaj',
        take: 'Pokušaj',
        takesLeft: 'Preostali broj pokušaja',
        skipTextQuestion: 'Spremni? Nastavite',
        retakeConfirmTitle: 'Jeste li sigurni da želite ponovno odgovoriti na ovo pitanje?',
        retakeConfirmSubmit: 'Da. Pokreni ponovno odgovaranje',
        submitInfoForward: 'Vaš sadašnji odgovor ćemo proslijediti, a zatim nastaviti automatski za',
        submitInfoForward2: 'sekunde(i)',
        nonAnswerableText: 'Ne treba odgovoriti na ovu poruku. Nakon ove poruke, prebacujete se izravno na sljedeće pitanje.',
        nonAnswerableVideo: 'Ne treba odgovoriti na ovaj videozapis. Nakon ovog videozapisa, prebacujete se izravno na sljedeće pitanje.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `You have ${answerMinutes} minutes ${answerSeconds} seconds time to answer the next question.`,
      },
      publisher: {
        toNextQuestion: timer => `Prijelaz na sljedeće pitanje za: ${timer}`,
        recordingStarts: timer => `Snimanje započinje za ${timer}`,
      },
      errors: {
        tooManyConnections: 'Ova je veza prekinuta jer već imate otvorenu vezu u drugoj kartici ili prozoru.',
        unsupportedBrowser: 'Nažalost, vaš preglednik ne podržava ovu radnju. Upotrijebite drugi preglednik.',
        networkError: 'Nema internetske veze.',
        reconnecting: 'Veza je prekinuta. Pokušaj ponovnog uspostavljanja veze.',
        generalError: 'Nešto je pošlo po zlu. Osvježite stranicu i pokušajte ponovno.',
        allowMediaDevicesError: 'Ovom se radnjom nisu uspješno dohvatili medijski uređaji (kamera ili mikrofon). Provjerite jeste li dopustili pregledniku da se koristi vašom kamerom i mikrofonom.',
        noAvailableDevicesError: 'Nismo uspjeli pronaći kameru ili mikrofon.',
        initPublisherError: 'Došlo je do pogreške i operacija nije uspjela. Provjerite jeste li pregledniku dopustili korištenje kamere i mikrofona te da ih ne koristi neka druga aplikacija i zatim pokušajte ponovo.',
      },
      browserInfo: {
        browserSupportTitle: 'Podržani preglednici',
        supportedBrowsers: 'Za ovu provjeru i razgovorom podržane su najnovije inačice preglednika Chrome, Firefox, Safari i Edge.',
        mobileSupported: 'Preglednici podržani na mobilnom uređaju',
        android: 'Android: Google Chrome (najnovija inačica), Firefox (najnovija inačica)',
        iOS: 'iOS: Safari (najnovija inačica)',
        latestVersion: 'Pazite da upotrebljavate najnoviju inačicu preglednika. Tako ćete osigurati da sve radi bez smetnji.',
        freezeInstruction: 'Ne pokrene li se snimanje videozapisa ili zaslon snimanja bude i dalje crn, osvježite stranicu.',
        unsupportedOnIos: 'Čini se da na operativnom sustavu iOS upotrebljavate nepodržani preglednik. Upotrijebite Safari.',
        ieUnsupported: 'Čini se da upotrebljavate preglednik Internet Explorer. Nažalost, u preglednikom Internet Explorer provjera ili razgovor nisu podržani. Upotrijebite drugi preglednik.',
        qualityTestNotSupported: 'Nažalost, preglednik kojim se koristite ne podržava provjeru hardvera. Možete nastaviti razgovor bez provjere kvalitete zvuka i videozapisa ili upotrijebite drugi preglednik.',
      },
      reconnectSuccess: 'Uspješno ponovno uspostavljanje veze!',
      continue: 'Nastavi',
    },

    withdraw: {
      title: 'Niste više zainteresirani za ovu poziciju?',
      description: 'Povucite se iz postupka regrutacije.',
      buttonText: 'Povlačenje iz postupka regrutacije',
      thankYouTitle: 'Hvala!',
      thankYouText: 'Ovim ste osoblje zaduženo za regrutaciju obavijestili da više niste zainteresirani za ovu poziciju.',
      confirm: 'Jeste li sigurni da se želite povući iz postupka regrutacije? Nakon povlačenja više nećete moći odgovarati u ovom, kao ni nijednom drugom, razgovoru za ovu poziciju.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Pošalji',
      continue: 'Nastavi',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Hvala na vašem odgovoru u videozapisu! Javit ćemo vam se ubrzo!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Hvala na sudjelovanju u ovom razgovoru!',
      reopenDescription: 'Ako ste slučajno zatvorili ovaj razgovor, ne brinite se! Možete ga ponovno otvoriti klikom na tipku koja se nalazi ispod razgovora!',
      reopenButtonText: 'Ponovno otvori razgovor',
      description1: 'Odlično! Odgovorili ste na sva pitanja i vaši su odgovori poslani primatelju.',
      descriptionsupport: mailto => `Ako ste slučajno zatvorili ovaj razgovor, obratite se našoj korisničkoj podršci na ${mailto} i ponovno ćemo otvoriti razgovor.`,
      descriptionfeedback: 'Vaše nam je iskustvo važno! Kako ste doživjeli odgovaranje na pitanja u videorazgovoru? Što biste nam predložili za unaprjeđenje naše usluge? Ovdje upišite svoje komentare.',
      feedbackbutton: 'Napišite nam što mislite!',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Osobna poruka',
    },

    closed: {
      title: 'Razgovor je završen ili su odgovori poslani',
      description: 'Poslali ste svoje odgovore ili je videorazgovor na koji ste pozvani već završen.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Vaš je videorazgovor spremljen!',
      description: 'Kada želite nastaviti videorazgovor, kliknite na poveznicu koju ste već primili e-poštom. Prethodno snimljeni odgovori u obliku videozapisa čekat će vas kada se vratite! Sretno s traženjem posla!',
      remember: 'Ne zaboravite poslati odgovore službeniku za kadrovske poslove nakon što odgovorite na sva pitanja u razgovoru.',
      deleteHistory: 'Ako videorazgovor budete vodili na javnom računalu, ne zaboravite izbrisati povijest pretraživanja. Na taj ćete način zaštititi privatnost svojeg razgovora.',
    },
    unpublished: {
      title: 'Razgovor nije još otvoren',
      publishTime: publishTime => `Razgovor se otvara ${publishTime}`,
    },
  },
}
